import { DateTime } from 'luxon';
import {
  booleanPreferenceSelector,
  userNameSelector,
} from '../../auth/selectors/auth.selectors';
import {
  Delineation,
  DelineationId,
  DelineationProcessor,
} from '../types/delineation.type';

const LOCAL_USER_DELINEATION_ID = -1;

export const createUserDelineation = (
  userName: string,
  waves: Delineation['waves'],
): Delineation => {
  const currentTime = DateTime.local().toISO();

  return {
    id: LOCAL_USER_DELINEATION_ID,
    createdAt: currentTime,
    expertName: userName,
    expertRole: 'user',
    updatedAt: currentTime,
    immutable: false,
    pipeline: 'resting',
    waves,
  };
};

export const isServerDelineationId = (delineationId: DelineationId) =>
  delineationId > LOCAL_USER_DELINEATION_ID;

export const getDelineationForUser = (
  delineations: Delineation[],
  userName: string,
): Delineation | undefined =>
  delineations.find(
    ({ expertName, immutable }) => expertName === userName && !immutable,
  );

export const getUserDelineations = (
  delineations: Delineation[],
): Delineation[] =>
  delineations.filter((delineation) => delineation.expertRole === 'user');

/**
 * This function is used to compare the delineation user with the account user. We cannot compare the user and the expert
 * by the id because because the delineation doesn't contain the expert id
 */
export const isUserDelineation = (
  userName?: string,
  delineation?: Delineation,
): boolean => {
  if (userName === undefined && delineation === undefined) {
    return false;
  }
  return userName === delineation?.expertName;
};

export const filterDelineations: DelineationProcessor = (
  delineations,
  getState,
): Delineation[] => {
  const showAlgoDelineation = booleanPreferenceSelector('showAlgoDelineation')(
    getState(),
  );
  const showCoworkerDelineation = booleanPreferenceSelector(
    'showCoworkerDelineation',
  )(getState());

  const userName = userNameSelector(getState()) ?? '';

  return delineations.filter(
    (delineation) =>
      delineation.expertName === userName ||
      (showAlgoDelineation &&
        ['algo', 'device'].includes(delineation.expertRole)) ||
      (showCoworkerDelineation && delineation.expertRole === 'user'),
  );
};
